import React from 'react';
import SelectField from '../../Forms/Input/SelectField';

interface PdfLeftSectionProps {
  selectedType: string | number;
  onChangeType: (value: string | number) => void;
  onView: () => void;
  options: { id: number; name: string; code?: string }[]; // 👈 Este tipo ya no se toca
  buttonLabel?: string;
}

const PdfLeftSection: React.FC<PdfLeftSectionProps> = ({
  selectedType,
  onChangeType,
  onView,
  options,
  buttonLabel = 'Generar Documento PDF',
}) => {
  return (
    <div className="w-full rounded-md border border-slate-200 bg-white p-4 shadow-sm dark:border-strokedark dark:bg-boxdark">
      <h4 className="mb-4 text-base font-semibold text-slate-800 dark:text-white">
        Tipo de Documento
      </h4>

      <div className="mb-4">
        <SelectField
          label=""
          name="documentType"
          iconKey="document"
          value={selectedType}
          onChange={(e) => onChangeType(e.target.value)}
          options={options.map((item) => ({
            label: item.name,
            value: item.id,
          }))}
          placeholder="Seleccione una opción"
        />
      </div>

      <div className="flex justify-end">
        <button
          type="button"
          onClick={onView}
          disabled={!selectedType}
          className="rounded bg-primary px-4 py-1.5 text-sm font-medium text-white hover:bg-opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
};

export default PdfLeftSection;
